import { MedicalInformation } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { SidePanelSlots, StyledFlex } from '@dreryk/react-components';

import { AttachmentsLinks } from '~legacy.patient';

type MedicalDataCategoryContentProps = {
   readonly medicalDataInformationEntry: MedicalInformation;
   readonly onShowMoreAttachmentsClick: VoidFunction;
};

export const MedicalDataCategoryContent = ({
   medicalDataInformationEntry,
   onShowMoreAttachmentsClick,
}: MedicalDataCategoryContentProps): JSX.Element => {
   return (
      <StyledFlex direction='column' gap='12px'>
         <SidePanelSlots.Expandable>{medicalDataInformationEntry.description}</SidePanelSlots.Expandable>
         {medicalDataInformationEntry.attachments ? (
            <AttachmentsLinks
               attachments={medicalDataInformationEntry.attachments}
               onShowMoreAttachmentsClick={onShowMoreAttachmentsClick}
            />
         ) : null}
      </StyledFlex>
   );
};
